export const WEBINAR_REGISTRATION_STATUS = {
  REGISTERED: 'REGISTERED',
  JOIN: 'JOIN',
  REGISTER: 'REGISTER',
} as const;

export type WebinarRegistrationStatus = typeof WEBINAR_REGISTRATION_STATUS[keyof typeof WEBINAR_REGISTRATION_STATUS];

export const WEBINAR_MODAL_STATE = {
  REGISTRATION: 'registration',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

export type WebinarModalState = typeof WEBINAR_MODAL_STATE[keyof typeof WEBINAR_MODAL_STATE];

export const JOIN_WINDOW_MINUTES = 15;

export const DEFAULT_MASKED_USER_ID = 'su_webinar_page';
export const DEFAULT_DURATION_MINUTES = 60;
export const FALLBACK_TIMEZONE = 'UTC';

// Date/Time formatting constants
export const DATE_FORMAT = {
  SHORT: 'short',
  NUMERIC: 'numeric',
  TWO_DIGIT: '2-digit',
} as const;
